import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import React from 'react';
import styled, { ThemeColors } from 'styled-components';
import IconButton from './IconButton';

interface Props {
    onClose: () => void;
    className?: string;
    bgColor?: keyof ThemeColors;
    topRight?: boolean; // Absoluteely placed
    shadow?: boolean;
}

const CloseButton: React.FC<Props> = ({
    onClose,
    className,
    bgColor = 'fillWhite',
    topRight = false,
    shadow = true,
}) => (
    <StyledIconButton
        topRight={topRight}
        shadow={shadow}
        bgColor={bgColor}
        className={`${className ? className : ''}`}
        onClick={() => onClose()}
        icon={faTimes}
    />
);

export default CloseButton;

const StyledIconButton = styled(IconButton)<{ topRight: boolean }>`
    ${({ topRight }) =>
        topRight &&
        `
    position: absolute;
    top: 1rem;
    right: 1rem;
  `}
`;
